export const InteractiveAnswers = {
    "客观题正确率":"客觀題正確率",
    "试题数":"試題數",
    "参与人数":"參與人數",
    "已批阅":"已批閱",
    "展示互动答题":"展示互動答題",
    "开始批阅":"開始批閱",
    "继续批阅":"繼續批閱",
    "批阅完成":"批閱完成",
    "总题数":"總題數",
    "平均分":"平均分",
    "平均答题正确率":"平均答題正確率",
    "平均得分率":"平均得分率",
    "数值评价题平均分":"數值評價題平均分",
    "已答":"已答",
    "未答":"未答",
    "已批":"已批",
    "未批":"未批",
    "未参与":"未參與",
    "批阅状态":"批閱狀態",
    "来源":"來源：",
    "互动答题标题":"互動答題標題",
    "互动答题详情":"互動答題詳情",
    "截止时间和发布时间冲突":"截止時間和發布時間沖突!",
    "已提交老师还未批改":"已提交，老師還未批改！",
    "等待老师批改点击下方查看试题可以查看作答情况":"等待老師批改，點擊下方“查看試題”可以查看作答情況",
    "您的得分":"您的得分：",
    "点击下方查看作答可以查看作答情况":"點擊下方“查看作答”可以查看作答情況",
    "点击下方的继续答题可以继续作答试题":"點擊下方的“繼續答題”可以繼續作答試題",
    "测试已结束":"測試已結束！",
    "点击下方的查看试题可以查看作答情况":"點擊下方的“查看試題”可以查看作答情況",
    "未参与测试已结束":"未參與！測試已結束！",
    "点击下方的“查看试题”进行查看":"點擊下方的“查看試題”進行查看",
    "查看作答":"查看作答",
    "查看试题":"查看試題",
    "继续答题":"繼續答題",
    "打分成功":"打分成功",
    "进入听讲模式":"進入聽講模式",
    "未交":"未交",
}